export default __webpack_public_path__ + "static/media/kitchen.ca90b070.webp";